export default __webpack_public_path__ + "static/media/MeiDianwafuMap.90637e30.jpg";